import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";
import SignupForm from "../components/authPartials/SignupForm";
import SigninForm from "../components/authPartials/SigninForm";
import { useGeneral } from "../components/contexts/GeneralContext";

const SigninPage = () => {
  const { discountCoupons } = useGeneral();
  return (
    <>
      <ScrollToTop />
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper className="">
          <SigninForm />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default SigninPage;
